import React from 'react';

const NolijLogo: React.FC = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Nolij "N" Logo - Clean modern design */}
      <rect
        x="2"
        y="2"
        width="28"
        height="28"
        rx="6"
        fill="var(--colorBrandForeground1)"
      />
      <path
        d="M9 24V8H12.5L19 18.5V8H23V24H19.5L13 13.5V24H9Z"
        fill="white"
      />
    </svg>
  );
};

export default NolijLogo;
